/**
 * Whether the game menu (Esc: Resume, Settings, Character select, Log out) is
 * open. One page-wide flag: the Esc handler (hooks/useGlobalInput.ts) opens and
 * closes it, the menu (GameMenu.tsx) renders it.
 */
import { useSyncExternalStore } from 'react';

let open = false;
const listeners = new Set<() => void>();

function set(next: boolean): void {
  if (open === next) return;
  open = next;
  for (const listener of listeners) listener();
}

export const gameMenuStore = {
  isOpen: (): boolean => open,
  open: (): void => set(true),
  close: (): void => set(false),
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};

export function useGameMenuOpen(): boolean {
  return useSyncExternalStore(gameMenuStore.subscribe, gameMenuStore.isOpen, () => false);
}
